import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { NotificationActions } from '@next/core-lib/notification';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';

import { OverviewService } from '../../services/overview.service';
import * as OverviewActions from '../actions/overview.actions';

@Injectable()
export class OverviewEffects {
  private readonly api = inject(OverviewService);
  private readonly actions$ = inject(Actions);
  private readonly localeService = inject(LocaleService);

  loadLabResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadLabResults),
      concatMap((action) =>
        this.api
          .getLabResults(action.keyword, action.pageNumber, action.pageSize)
          .pipe(map((labResults) => OverviewActions.loadLabResultsSuccess({ labResults }))),
      ),
    ),
  );

  downloadReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.downloadReport),
      switchMap(({ id }) =>
        this.api.getReport(id).pipe(
          tap((response: HttpResponse<Blob>) => {
            const contentDisposition = response.headers.get('Content-Disposition');
            const filename = contentDisposition
              .split(';')[1]
              .split('filename')[1]
              .split('=')[1]
              .trim()
              .replace(/^"|"$/g, '');

            const elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(response.body);
            elem.download = filename;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
          }),
          map(() => OverviewActions.downloadReportSuccess()),
          catchError(() => {
            const message = this.localeService.translate('labresults.no-report-error');
            return of(
              OverviewActions.downloadReportFailed(),
              NotificationActions.errorSnackbar({ message }),
            );
          }),
        ),
      ),
    ),
  );
}
